import {
  Text,
  Grid,
  GridItem,
  VStack,
  AspectRatio,
  GridItemProps
} from '@chakra-ui/react'
import Image from 'next/image'

const KeyIngredientItem = ({
  title,
  src,
  desc,
  ...props
}: {
  title: string
  src: any
  desc?: string
} & GridItemProps) => {
  return (
    <GridItem
      colSpan={{
        base: 6,
        md: 4
      }}
      {...props}
    >
      <VStack alignItems="center">
        <AspectRatio w={140} ratio={1 / 1} position="relative">
          <Image
            src={src}
            alt={title || ''}
            fill
            style={{
              border: '4px solid #497538',
              borderRadius: '50%'
            }}
          />
        </AspectRatio>

        <Text
          textStyle="oralcareKeyIngredientTitle"
          textTransform="uppercase"
          textAlign="center"
          mt={4}
          w={160}
          color="#497538"
        >
          {title}
        </Text>
        <Text textStyle="oralcareKeyIngredient" textAlign="center" w={160}>
          {desc}
        </Text>
      </VStack>
    </GridItem>
  )
}

const KeyIngredient = () => {
  return (
    <VStack w="100%" my={10} alignItems="center">
      <Text
        data-aos="fade-up"
        textTransform="uppercase"
        textStyle="oralcareOptimizingTitle"
        textAlign="center"
        color="#497538"
      >
        KEY INGREDIENTS
      </Text>

      <Grid
        data-aos="fade-up"
        w={{
          base: '100%',
          md: '70%'
        }}
        templateColumns="repeat(12, 1fr)"
        pt={10}
        gap={{
          md: 12,
          base: 4
        }}
        justifyContent="center"
      >
        <KeyIngredientItem
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/propolis-1714038749412.png'
          }
          title="Propolis"
          desc="Coagulates and removes the hidden protein minerals between your teeth leaving your mouth clean and fresh after gargling"
        />
        <KeyIngredientItem
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ginseng-flower-icon-1714038749416.png'
          }
          title="Ginseng Flower"
          desc="Anti-oxidant effect, strengthens your teeth, prevent gum disease"
        />
        <KeyIngredientItem
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/gante-1714038749413.png'
          }
          title="Gante Extract"
          desc="Decompose Nicotine, brightens your teeth, remove yellowish on your teeth"
        />
        <KeyIngredientItem
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/green-tea-icon-1714038749415.png'
          }
          title="Green tea"
          colStart={{
            base: 'auto',
            md: 3
          }}
          desc="Terminates oral bad germs to make teeth more healthier and stronger"
        />
        <KeyIngredientItem
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/xylitol-1714038749413.png'
          }
          title="Xylitol"
          desc="Helps to complete oral freshness and promote salivation"
        />
      </Grid>

      <AspectRatio
        data-aos="fade-up"
        mt={{
          base: 10
        }}
        w={{
          base: '160px',
          sm: '160px',
          xl: '160px'
        }}
        ratio={999 / 864}
        position="relative"
      >
        <Image
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/korea-icon-1714038749411.png'
          }
          alt="korea icon"
          fill
        />
      </AspectRatio>
    </VStack>
  )
}

export default KeyIngredient
